module.exports = __webpack_public_path__ + "img/css.1a91565b.jpg";